export const MODULE_NAME = 'consent'

export const didomiConfig = {
  user: {
    bots: {
      consentRequired: false,
      types: ['crawlers', 'performance'],
      extraUserAgents: [],
    },
  },
}

export const forbiddenPages =
  /staticPagesModule-cookies|staticPagesModule-privacyMain|usersModule-travelerLogin|source_is_app|usersModule-signIn/

export const ANALYTICS_DIDOMI_COOKIE = 'c:googleana-4TXnJigR'
export const ADWORDS_DIDOMI_COOKIE = 'google'
